// extracted by mini-css-extract-plugin
export default {"personaContainer":"PersonaCard_personaContainer__8KQLf","personaItem":"PersonaCard_personaItem__IWWCq","personaImage":"PersonaCard_personaImage__bsQbU"};